"use client";

import React, { useMemo } from "react";
import { UnifiedAppProvider, StubProviders } from "@team-shiphouse/shiphouse-sdk/client";
import { getStoreId, isDevelopment } from "@/config/env";

export default function WebBuilderProvider({
  children,
  sdkConfig,
}: {
  children: React.ReactNode;
  sdkConfig?: { storeId?: string; testMode?: boolean };
}) {
  const unifiedConfig = {
    storeId: sdkConfig?.storeId ?? getStoreId(),
    testMode: sdkConfig?.testMode ?? isDevelopment(),
  };

  // Mock route context for preview mode
  const routeContext = useMemo(() => ({
    site: "preview",
    page: "canvas",
    additionalPath: [],
    fullPath: ["preview", "canvas"],
    fullRoute: "/preview/canvas",
  }), []);

  return (
    <UnifiedAppProvider
      config={unifiedConfig}
      RouteProvider={StubProviders}
      routeContext={routeContext}
    >
      {children}
    </UnifiedAppProvider>
  );
}
